import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

export default class GoogleSignInService {
  
  static async signInWithGoogle() {
    const auth = getAuth(); // Получаем экземпляр Firebase Auth
    const provider = new GoogleAuthProvider(); // Создаём провайдера Google

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // 🔹 Получаем ID-токен пользователя
      const token = await user.getIdToken();

      console.log("✅ Успешный вход через Google:", user);

      // 🔹 Сохраняем `user_id` и `auth_token` в localStorage
      localStorage.setItem("user_id", user.uid);
      localStorage.setItem("auth_token", token);

      return {
        success: true,
        uid: user.uid,
        token: token, // ✅ Теперь возвращаем и токен
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL
      };

    } catch (error) {
      console.error("❌ Ошибка входа через Google:", error);
      return { success: false, error: error.message };
    }
  }

  static async signOut() {
    const auth = getAuth();
    try {
      await signOut(auth);
      console.log("🚪 Пользователь успешно вышел из системы.");
      return true; // ✅ Успешный выход
    } catch (error) {
      console.error("❌ Ошибка при выходе:", error);
      throw error;
    }
  }

}